import useResource from "./use-resource";

export default function useNumerotation(profileBailleurId) {
  const {
    resource: numerotation,
    error,
    isLoading,
    update,
  } = useResource(
    profileBailleurId ? `profiles/${profileBailleurId}/numerotation` : null,
  );

  return {
    numerotation,
    error,
    isLoading,
    updateNumerotation: update,
  };
}
